<template>
<div class="displaySelector">
    <div class="subCell  rounded">
        <div class="outputSelectorHeading">
            <div class="amber">Display Output</div>
            <div class="flexRow">
            <div>
                
<input type="radio" id="cases" name="outputSelect" value="cases" :checked="displayOutput === 'cases'" @change="selectOutput"><label for="cases">Cases</label></div>
<div><input type="radio" id="deaths" name="outputSelect" value="deaths" :checked="displayOutput === 'deaths'" @change="selectOutput">
<label for="deaths">Deaths</label></div>
</div>
        </div>
        <div class="flexRow mobileDeflex" style="justify-content: space-between">
          
            <label>Vaccination Goal:</label><select class="selectList" :value="vaccinationGoal" @change="selectVaxGoal">
            <option value="-">---Select Target %---</option>
            <option value="100M">100 Million in 100 Days (30.3%)</option>
            <option value="200M">200 Million in 100 Days (60.6%)</option>
            </select>
            </div>
    <v-slider
    :value="vaccinationRateSliderNum"
          :tick-labels="labels"
          min="1"
          max="7"
          ticks="always"
          tick-size="6"
          thumb-size="20"
          track-color="#fff"
          thumb-color="#f7941d"
          track-fill-color="#fff"
          color="#fff"
          height="10"
          @change="selectVaxRate"
        >
         
        </v-slider>
        <p style="margin-top: .75rem; margin-bottom: auto" class="tableDesc printHide">Select the desired vaccination rate to see medical consequences.</p>
    </div>
</div>
</template>
<script>
import { mapState } from 'vuex'

export default {
     computed: {
        ...mapState(['vaccinationGoal', 'displayOutput', 'selectedMap', 'vaccinationRateSlider','vaccinationRateSliderNum'])
    },
    methods: {
        selectVaxRate(value) {
          let id;
          switch(value) {
            case 1: id = "-30%"; break;
            case 2: id = "-20%"; break;
            case 3: id = "-10%"; break;
            case 4: id = "baseRate"; break;
            case 5: id = "+10%"; break;
            case 6: id = "+20%"; break;
            case 7: id = "+30%"; break;
            default: id = "baseRate"; break;
          }
          this.$store.dispatch('selectVaxRateNum', value);
          this.$store.dispatch('selectVaxRate', id);
        },
        selectOutput(event) {
          this.$store.dispatch('selectOutput', event.target.value);
        },
        selectVaxGoal(event) {
          this.$store.dispatch('selectVaxGoal', event.target.value);
        },

    },
    data() {
let handleSize;
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        handleSize = 40;
    }
    else {
      handleSize = 20;
    }
      

        return {
            labels: [
      '-30%',
      '-20%',
      '-10%',
      'Base Rate',
      '+10%',
      '+20%',
      '+30%'
    ],
    value: 4,
    handleSize: handleSize
}
}
}
</script>